import { useState } from "react";

import { ServiceOrderType } from "../../../_constants/serviceOrder.ts";
import { BusinessServiceType } from "../../../common/enums/sharedEnums.ts";
import NewServiceBusinessSelector from "../containers/ServiceOrderingBusinessSelector";
import ServiceOrderingContainer from "../containers/ServiceOrderingContainer";
import { useServiceInventoryStore } from "../store/ServiceInventoryStore";

const ServiceOrderingPage = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const { setCurrentForm, setBusinessServiceType } = useServiceInventoryStore(state => state);

  const handleContinueToStep2 = (serviceId: string) => {
    setBusinessServiceType(serviceId as BusinessServiceType);
    
    switch (serviceId) {
      case BusinessServiceType.RENTAL_MANAGEMENT:
      setCurrentForm(ServiceOrderType.OUTGOING_INVENTORY);
      break;
      case BusinessServiceType.ERP_EXPRESS:
      setCurrentForm(ServiceOrderType.ERP_EXPRESS);
      break;
      case BusinessServiceType.CONDOMINIUM_MANAGEMENT:
      setCurrentForm(ServiceOrderType.PPPT);
      break;
      case BusinessServiceType.PROPERTY_SALES:
      setCurrentForm(ServiceOrderType.DIAGNOSTIC);
      break;
      case BusinessServiceType.RENOVATION_DEVELOPMENT:
      setCurrentForm(ServiceOrderType.DIAGNOSTIC)
      break;
    }
    
    setCurrentStep(2);
  };

  const handleBackToStep1 = () => {
    setCurrentStep(1);
  };

  return currentStep === 1 ? (
    <NewServiceBusinessSelector onContinue={handleContinueToStep2} />
  ) : (
    <ServiceOrderingContainer onBack={handleBackToStep1} />
  );
};

export default ServiceOrderingPage;
